module.exports = __webpack_public_path__ + "img/flex5_5_Extended-menu-desktop.61953e18.png";